import { useMemo } from 'react';
import { RequiredNotification } from '@Components/index';
import { useAppDispatch } from '@Hooks/index';
import { modalActions } from '@Store/slices/modalSlice';
import { ViewTab } from '../../../ViewTab.enum';

interface DeleteModalProps {
  showModal: boolean;
  deleteName: string;
  activeTab: keyof typeof ViewTab;
  handleDeleteItemMaterial: () => void;
  handleDeleteItemDocument: () => void;
}

const ItemDeleteModal: React.FC<DeleteModalProps> = ({
  showModal,
  deleteName,
  handleDeleteItemMaterial,
  handleDeleteItemDocument,
  activeTab,
}) => {
  const dispatch = useAppDispatch();

  const messageText = useMemo(() => {
    if (activeTab === ViewTab.DOCUMENTS)
      return `Are you sure you want to delete document ${JSON.parse(deleteName)?.docName}?`;
    return `Are you sure you want to delete material no.${deleteName}?`;
  }, [activeTab, deleteName]);

  const onSuccess = useMemo(() => {
    if (activeTab === ViewTab.DOCUMENTS) {
      return handleDeleteItemDocument;
    }
    return handleDeleteItemMaterial;
  }, [activeTab, handleDeleteItemDocument, handleDeleteItemMaterial]);

  return (
    <RequiredNotification
      title="Delete Material"
      message={messageText}
      isModalOpen={showModal}
      textSuccessBtn="Yes, Delete"
      textCancelBtn="No, Thanks"
      handleCancel={() =>
        dispatch(
          modalActions.setStatusModal({
            key: '',
            status: false,
            type: '',
          })
        )
      }
      handleSuccess={onSuccess}
      isDeleteNotification
    />
  );
};

export default ItemDeleteModal;
